<mat-card class="default mb-4" [formGroup]="form">
  <mat-card-title>{{ 'shopper-estimates-dashboard.editor.patient-info-title' | translate }}</mat-card-title>
  <mat-card-content fxLayout="column">
    <div fxFlex="grow" fxLayoutGap="1rem">
      <mat-form-field fxFlex>
        <mat-label>{{ 'shopper-estimates-dashboard.editor.form.first-name' | translate }}</mat-label>
        <input matInput formControlName="patientFirstName" required />
        <mat-error *ngIf="form.controls.patientFirstName.hasError('required')">
          {{ 'common.required' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>{{ 'shopper-estimates-dashboard.editor.form.last-name' | translate }}</mat-label>
        <input matInput formControlName="patientLastName" required />
        <mat-error *ngIf="form.controls.patientLastName.hasError('required')">
          {{ 'common.required' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>{{ 'shopper-estimates-dashboard.editor.form.dob' | translate }}</mat-label>
        <mmx-date-selector-input formControlName="patientDOB" [dob]="true"></mmx-date-selector-input>
        <mat-error *ngIf="form.controls.patientDOB.hasError('required')">
          {{ 'common.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div fxFlex="grow" fxLayoutGap="1rem">
      <mat-form-field fxFlex>
        <mat-label>{{ 'shopper-estimates-dashboard.editor.form.email' | translate }}</mat-label>
        <input matInput formControlName="patientEmail" type="email" />
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>{{ 'shopper-estimates-dashboard.editor.form.phone' | translate }}</mat-label>
        <mmx-phone-field formControlName="patientPhone"></mmx-phone-field>
        <mat-error *ngIf="form.controls.patientPhone.hasError('required')">
          {{ 'common.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </mat-card-content>
</mat-card>
